import React from "react";
import { List, Datagrid, TextField, Button } from "react-admin";
import { useState } from "react";
import NewsgateTransformDialog from "./NewsgateTransformDialog";
import dataProvider from "../data/providers/unionDataProvider";

const NewsgateTransformList = (props) => {
  const [open, setOpen] = useState(false);
  const [transformId, setTransformId] = useState(false);
  const [seasons, setSeasons] = useState(false);

  async function handleTransformCancel() {
    setOpen(false);
  }

  async function handleTransformConfirm(id, seasonCode, startDate, endDate) {
    // eslint-disable-next-line no-unused-vars
    const r = await dataProvider
      .getBaseProvider()
      .providers.newsgateTransforms.sendToNewsgate(null, {
        id,
        seasonCode,
        startDate,
        endDate
      });
    setOpen(false);
  }

  const CreateDialogButton = ({ record }) => (
    <Button label="Send" onClick={() => buttonClick(record)} />
  );

  async function buttonClick(record) {
    const seasons = await dataProvider
      .getBaseProvider()
      .providers.availableSeasons.getList(null, {});
    setSeasons(seasons);
    setTransformId(record.id);
    setOpen(true);
  }

  return (
    <React.Fragment>
      <List {...props} bulkActionButtons={false}>
        <Datagrid rowClick="show">
          <TextField source="name" />
          <CreateDialogButton />
        </Datagrid>
      </List>
      <NewsgateTransformDialog
        open={open}
        transformId={transformId}
        handleCancel={handleTransformCancel}
        handleTransform={handleTransformConfirm}
        seasons={seasons}
      />
    </React.Fragment>
  );
};

export default NewsgateTransformList;
